import { TargetTimeline } from './Timeline/TargetTimeline';
import { IntegrityStatusCards } from './IntegrityStatusCard';
import { BidirectionalCard } from './BidirectionalMapChart/BidirectionalCard';
import { Button, Separator } from '@ais-ui/ui-core';
import { useMemo, useRef } from 'react';
import { useSelectionState } from '../../../components/SelectionStateProvider';
import { useDashboardExport } from '../../../components/DetailsPage/useDashboardExport';

export const VesselDashboardLayout = () => {
  const { currentTargetInfo } = useSelectionState();

  const dashboardRef = useRef<HTMLDivElement>(null);

  const name = useMemo(() => {
    if (!currentTargetInfo) {
      return undefined;
    }

    if ('name' in currentTargetInfo) {
      return currentTargetInfo.name;
    }

    if (
      'basic' in currentTargetInfo &&
      currentTargetInfo.basic &&
      'vesselName' in currentTargetInfo.basic
    ) {
      return currentTargetInfo.basic.vesselName;
    }

    return undefined;
  }, [currentTargetInfo]);

  const imo = useMemo(() => {
    if (!currentTargetInfo) {
      return undefined;
    }

    if ('imo' in currentTargetInfo) {
      return parseFloat(String(currentTargetInfo.imo));
    }

    if (
      'basic' in currentTargetInfo &&
      currentTargetInfo.basic &&
      'vesselImoNumber' in currentTargetInfo.basic
    ) {
      return parseFloat(String(currentTargetInfo.basic.vesselImoNumber));
    }

    return undefined;
  }, [currentTargetInfo]);

  const { handleDownload } = useDashboardExport(
    dashboardRef,
    imo ? String(imo) : 'snapshot'
  );

  if (!imo) {
    return null;
  }

  return (
    <div
      className="h-full mr-4 space-y-4"
      id="dashboard-content"
      ref={dashboardRef}
    >
      <div className="flex items-end justify-between space-y-2">
        <h2 className="text-3xl font-bold tracking-tight">{name}</h2>
        <div className="flex items-center space-x-2 no-export">
          <Button onClick={handleDownload} className="no-export">
            Download
          </Button>
        </div>
      </div>
      <Separator></Separator>
      <TargetTimeline imo={imo} />
      <IntegrityStatusCards imo={imo}></IntegrityStatusCards>
      <div>
        <BidirectionalCard imo={imo}></BidirectionalCard>
      </div>
    </div>
  );
};
